import { Component, ElementRef, OnInit} from '@angular/core';
import { PopoverController } from '@ionic/angular'
import { PagesProvider } from '../../../providers/pages/pages.provider';
import { TeacherProvider } from '../../../providers/teacher/teacher.provider';
import { ArticlesProvider } from '../../../providers/articles/articles.provider';
import { Article } from '../../../models/article';
import { Router } from '@angular/router';
import { Filters, FilterSection, FilterItem } from 'src/app/components/resources-filter/resources-filter.component';
import { plainToClass } from 'class-transformer';
import { ResourcesBase } from '../../resources/resources-base.page';
import { ResourcesCssService } from '../../resources/resources-css.service'
import { WindowService } from '../../../services/window.service'
import { ResourceSortItem } from 'src/app/components/resources-header/resources-header.component';
import { Teacher } from 'src/app/models/teacher';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, map, takeUntil } from 'rxjs';
import { TeacherStore } from 'src/app/stores/teacher.store';

@Component({
  selector: 'app-article',
  templateUrl: './article.page.html',
  styleUrls: ['./article.page.scss'],
})
export class ArticlePage implements OnInit {

  url: String
  article: Article = Article.defaults()
  articles: Article[]
  viewDisplayed: boolean = false

  articleContent: any
  articleSummary: any

  ngUnsubscribeTeacher = new Subject();

  constructor(element: ElementRef,
    private teacherProvider: TeacherProvider,
    private articlesProvider: ArticlesProvider,
    private teacherStore: TeacherStore,
    public resourcesCssService: ResourcesCssService,
    public windowService: WindowService,
    private popoverCtrl: PopoverController,
    private router: Router,
    private sanitizer: DomSanitizer) {

    }

  ngOnInit() {
    this.windowService.width$.subscribe((value: number) =>  this.resourcesCssService.width = value)
    this.url = this.router.url.slice(6)
    this.articlesProvider.getArticle(this.url).subscribe(r => {
      this.article = r
      this.articleContent = this.sanitizer.bypassSecurityTrustHtml(this.article.content)
      this.articleSummary = this.sanitizer.bypassSecurityTrustHtml(this.article.summary)

    this.teacherStore.state$
        .pipe(takeUntil(this.ngUnsubscribeTeacher))
        .subscribe(() => {
          const teacher = this.teacherProvider.teacher;
          this.articles = teacher.articles;
          this.viewDisplayed = true;          
        });
    })
  }

  ngOnDestroy(){
    this.ngUnsubscribeTeacher.next(true);
    this.ngUnsubscribeTeacher.complete();
  }

}
